import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function CardTemp(props) {
  return (
    <div
      className="card"
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'whitesmoke',
        marginLeft: '15px',
        width: '235px',
        marginBottom: '20px',
      }}
      id="homecard"
    >
      <Link
        to={props.cardLink}
        style={{
          marginTop: '8px',
          paddingLeft: '4px',
        }}
      >
        <FontAwesomeIcon icon={props.imgSrc} size={24} color="blue" />

        <div style={{ marginTop: '8px' }}>
          <div
            style={{
              textAlign: 'center',
              color: 'blue',
              textDecoration: 'none',
            }}
          >
            <h6>
              {props.cardIcon}
              {props.imgTitle}
            </h6>
          </div>
          <hr style={{ borderTop: '2px solid blue', margin: '10px' }} />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <p>
              {props.answerIcon}
              {props.def1} <br />
              {props.def2} <br />
              {props.def3} <br />
              {props.def4} <br />
              {props.def5} <br />
              {props.def6} <br />
              {props.def7} <br />
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
}
export default CardTemp;
